module.exports = __webpack_public_path__ + "static/media/haisibao.a1155dda.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/logo/haisibao.svg
// module id = 41
// module chunks = 6